'use client'

import {
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Stack,
  useMediaQuery,
  useTheme,
} from '@mui/material'
import { useState } from 'react'

import { Button } from '../button/button'

type Option = { label: string; value: string }

export interface ButtonSelectorProps {
  label: string
  options: Option[]
  value?: string
  onChange: (value: string) => void
}

export const ButtonSelector = ({
  label,
  options,
  value,
  onChange,
}: ButtonSelectorProps) => {
  const theme = useTheme()
  const isDesktop = useMediaQuery(theme.breakpoints.up('md'))

  const [currentValue, setCurrentValue] = useState<string | undefined>(value)

  const handleChange = (newValue: string) => {
    setCurrentValue(newValue)
    onChange(newValue)
  }

  if (!isDesktop) {
    const labelId = `${label.split(' ').join('')}-select`
    return (
      <FormControl fullWidth>
        <InputLabel id={labelId}>{label}</InputLabel>
        <Select
          value={currentValue}
          label={label}
          onChange={e => handleChange(e.target.value)}
          labelId={labelId}
        >
          {options.map(option => (
            <MenuItem key={`option-${option.value}`} value={option.value}>
              {option.label}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    )
  }

  return (
    <Stack direction="row" gap={3}>
      {options.map(option => {
        const isActive = currentValue === option.value

        return (
          <Button
            key={`option-${option.value}`}
            variant={isActive ? 'contained' : 'outlined'}
            onClick={() => handleChange(option.value)}
            color="primary"
            disableElevation
            disableRipple
          >
            {option.label}
          </Button>
        )
      })}
    </Stack>
  )
}
